import PageHeader from "@/components/PageHeader";

export default function Legal({ type = "privacy" }) {
  const isPrivacy = type === "privacy";
  return (
    <div data-testid="legal-page">
      <PageHeader overline="Legal" title={isPrivacy ? "Privacy Policy" : "Terms & Conditions"} subtitle={isPrivacy ? "How ElitzPacks collects, uses and protects your information." : "The terms governing the use of the ElitzPacks website and services."} />
      <section className="mx-auto max-w-3xl px-5 lg:px-10 py-10 space-y-6 text-muted-foreground leading-relaxed">
        {isPrivacy ? (
          <>
            <p>ElitzPacks respects your privacy. We collect only the information you provide through our forms — such as your name, contact details and packaging requirements — to respond to enquiries and process orders.</p>
            <p>We do not sell your data. Information is stored securely and used solely to provide quotations, fulfil orders and improve our services. You may request deletion of your data at any time by contacting us.</p>
            <p>Our website may use cookies to enhance your browsing experience. By using this site, you consent to this policy.</p>
          </>
        ) : (
          <>
            <p>By accessing the ElitzPacks website, you agree to use it for lawful purposes only. All content, imagery and product descriptions are the property of ElitzPacks.</p>
            <p>Quotations are estimates and subject to confirmation. Custom-printed orders are non-returnable unless defective. Delivery timelines are indicative and may vary by location and order size.</p>
            <p>ElitzPacks reserves the right to update these terms at any time. Continued use of the site constitutes acceptance of the latest terms.</p>
          </>
        )}
      </section>
    </div>
  );
}
